import { FOCO_VISIVEL } from 'utils/foco';

interface AvisoDoExtratoProps {
  linhas: string[];
}

/** Bloco amarelo-claro com ícone de alerta do design; cada linha é um parágrafo (PREM-02, PREM-12). */
export default function AvisoDoExtrato({ linhas }: AvisoDoExtratoProps) {
  return (
    <div tabIndex={0} className={`mb-4 flex items-start gap-3.5 rounded-2xl bg-brand-yellow-light px-[22px] py-[18px] ${FOCO_VISIVEL}`}>
      <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="var(--brand-blue)" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" className="mt-px shrink-0">
        <path d="M10.29 3.86 1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" />
        <path d="M12 9v4" />
        <path d="M12 17h.01" />
      </svg>
      <div>
        {linhas.map(linha => (
          <p key={linha} className="m-0 text-[13px] leading-[1.6] text-content">
            {linha}
          </p>
        ))}
      </div>
    </div>
  );
}
